import { render, staticRenderFns } from "./terms_modal.vue?vue&type=template&id=991ea0ee&scoped=true"
import script from "./terms_modal.vue?vue&type=script&lang=js"
export * from "./terms_modal.vue?vue&type=script&lang=js"
import style0 from "./terms_modal.vue?vue&type=style&index=0&id=991ea0ee&prod&lang=less&scoped=true"
import style1 from "@/assets/h5css/account/terms_modal.less?vue&type=style&index=1&id=991ea0ee&prod&scoped=true&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "991ea0ee",
  null
  
)

export default component.exports